import React, { PureComponent } from 'react'
import { func, string } from 'prop-types'
import { csv } from '../../../../utils/api/getSigns'
import { CurrentTime } from '../../../../utils/CurrentTime'
import { List } from 'semantic-ui-react'

class Csv extends PureComponent {
  download = () => {
    this.props.download(csv, `signs_${CurrentTime()}.csv`)
    this.props.toggle(false)
  }

  render() {
    return (
      <List.Item onClick={() => this.download()}>
        <List.Icon name="file excel" size="large" />
        <List.Content>
          <List.Header>CSV</List.Header>
        </List.Content>
      </List.Item>
    )
  }
}

Csv.propTypes = {
  theme: string.isRequired,
  download: func.isRequired,
  toggle: func.isRequired,
}

export default Csv



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/Downloads/Csv.jsx